import { AbstractControl, ValidatorFn } from '@angular/forms';
import { Regex } from '@app/shared/validators/regex';
import { createValidationError, PcsValidationErrors } from '@app/shared/validators/validation-errors';
import { hasNoValue } from '@app/util';
import { parseToDayjs } from '@util/date-util';
import * as R from 'ramda';

export const stringValueAsNumberValidator = (value: string): PcsValidationErrors | null => {
  const numRegex = Regex.numberRegex;
  return hasNoValue(value) || numRegex.test(value) ? null :
    createValidationError('stringAsNumber', 'general.invalidNumber');
};

export const stringAsNumberValidator = (control: AbstractControl): PcsValidationErrors | null =>
  stringValueAsNumberValidator(control.value);

export const stringAsDecimalNumberValidator = (control: AbstractControl): PcsValidationErrors | null => {
  const numRegex = Regex.decimalNumberRegex;
  return hasNoValue(control.value) || numRegex.test(control.value) ? null :
    createValidationError('stringAsDecimalNumber', 'general.invalidDecimalNumber');
};

export const stringValueAsDecimalNumberValidator = (value: string): PcsValidationErrors | null => {
  const numRegex = Regex.decimalNumberRegex;
  return hasNoValue(value) || numRegex.test(value) ? null :
    createValidationError('stringValueAsDecimalNumberValidator', 'general.invalidDecimalNumber');
};

export const stringAsMomentValueValidator = (format: string): ValidatorFn => (control: AbstractControl): PcsValidationErrors | null => {
  // year and day pattern should be upper case
  const timeFormat = R.startsWith('HH');
  const dateFormat = R.complement(R.includes('HH'));
  const dateTimeFormat = R.allPass([R.includes('HH'), R.complement(timeFormat)]);

  const adjustFormat = R.cond([
    [dateTimeFormat, (f) => {
      const formatComponents = R.split(' ', f);
      return `${R.head(formatComponents).toUpperCase()} ${R.tail(formatComponents)}`;
    }],
    [dateFormat, (f) => f.toUpperCase()],
    [R.T, R.identity]
  ]);

  const dayValue = parseToDayjs(control.value, adjustFormat(format), true);
  return hasNoValue(control.value) || dayValue.isValid() ? null :
    createValidationError('stringAsMomentValue', 'imParameters.input.error.invalidDateFormat');
};
